export default {
    //报表中心
    "report.report.463915-0": "返回",
    "report.report.463915-1": "异常统计",
    "report.report.463915-2": "能耗统计",
    "report.report.463915-3": "用电数据",
    "report.report.463915-4": "设备电费",
    "report.report.463915-5": "操作日志",
    "report.report.463915-6": "加载中...",



    //异常数据
    "abnormal.abnormal.628134-0": "用户列表",
    "abnormal.abnormal.628134-1": "搜索",
    "abnormal.abnormal.628134-2": "请输入用户名称",
    "abnormal.abnormal.628134-3": "暂无设备",
    "abnormal.abnormal.628134-4": "请选择周期",
    "abnormal.abnormal.628134-5": "日",
    "abnormal.abnormal.628134-6": "月",
    "abnormal.abnormal.628134-7": "季",
    "abnormal.abnormal.628134-8": "年",
    "abnormal.abnormal.628134-9": "自定义",
    "abnormal.abnormal.628134-10": "请选择时间",
    "abnormal.abnormal.628134-11": "查询",
    "abnormal.abnormal.628134-12": "导出",
    "abnormal.abnormal.628134-13": "异常占比",
    "abnormal.abnormal.628134-14": "异常统计",
    "abnormal.abnormal.628134-15": "异常原因",
    "abnormal.abnormal.628134-16": "异常（次）",
    "abnormal.abnormal.628134-17": "异常列表",
    "abnormal.abnormal.628134-18": "设备名称",
    "abnormal.abnormal.628134-19": "设备编号",
    "abnormal.abnormal.628134-20": "异常名称",
    "abnormal.abnormal.628134-21": "异常时间",
    "abnormal.abnormal.628134-22": "暂无异常消息",
    "abnormal.abnormal.628134-23": "请选择日期",
    "abnormal.abnormal.628134-24": "异常比例",
    "abnormal.abnormal.628134-25": "总量",
    "abnormal.abnormal.628134-26": "本期异常次数",
    "abnormal.abnormal.628134-27": "上期异常次数",


    // 操作日志
    "operation_log.operation.506627-0": "请选择时间",
    "operation_log.operation.506627-1": "登录账号",
    "operation_log.operation.506627-2": "设备编号",
    "operation_log.operation.506627-3": "设备名称",
    "operation_log.operation.506627-4": "查询",
    "operation_log.operation.506627-5": "导出",
    "operation_log.operation.506627-6": "用户昵称",
    "operation_log.operation.506627-7": "操作内容",
    "operation_log.operation.506627-8": "是否成功",
    "operation_log.operation.506627-9": "操作时间",
    "operation_log.operation.506627-10": "暂无数据",

    //能耗数据
    "energy.energy.528939-0": "用户列表",
    "energy.energy.528939-1": "搜索",
    "energy.energy.528939-2": "请输入用户名称",
    "energy.energy.528939-3": "暂无设备",
    "energy.energy.528939-4": "日",
    "energy.energy.528939-5": "月",
    "energy.energy.528939-6": "年",
    "energy.energy.528939-7": "请选择日期",
    "energy.energy.528939-8": "查询",
    "energy.energy.528939-9": "导出",
    "energy.energy.528939-10": "能耗对比",
    "energy.energy.528939-11": "今日用电（kw·h）",
    "energy.energy.528939-12": "昨日同期（kw·h）",
    "energy.energy.528939-13": "用电趋势",
    "energy.energy.528939-14": "本月用电（kw·h）",
    "energy.energy.528939-15": "上月同期（kw·h）",
    "energy.energy.528939-16": "今年用电（kw·h）",
    "energy.energy.528939-17": "去年同期（kw·h）",
    "energy.energy.528939-18": "能耗分时统计",
    "energy.energy.528939-19": "能耗同比",
    "energy.energy.528939-20": "能耗排名",
    "energy.energy.528939-21": "设备名称",
    "energy.energy.528939-22": "设备编号",
    "energy.energy.528939-23": "能耗",
    "energy.energy.528939-24": "电压",
    "energy.energy.528939-25": "本月",
    "energy.energy.528939-26": "本季度",
    "energy.energy.528939-27": "今年",
    "energy.energy.528939-28": "总量",
    "energy.energy.528939-29": "上期能耗",
    "energy.energy.528939-30": "本期能耗",

    //用电数据
    "electricity.electricity.543197-0": "请选择时间",
    "electricity.electricity.543197-1": "设备编号",
    "electricity.electricity.543197-2": "设备名称",
    "electricity.electricity.543197-3": "查询",
    "electricity.electricity.543197-4": "导出",
    "electricity.electricity.543197-5": "用电量",
    "electricity.electricity.543197-6": "操作",
    "electricity.electricity.543197-7": "查看",
    "electricity.electricity.543197-8": "暂无用电数据",
    "electricity.electricity.543197-9": "时间",
    "electricity.electricity.543197-10": "电量",

    //设备电费
    "deviceMoney.deviceMoney.560758-0": "设备充值明细",
    "deviceMoney.deviceMoney.560758-1": "设备电费明细",
    "deviceMoney.deviceMoney.560758-2": "请选择时间",
    "deviceMoney.deviceMoney.560758-3": "用户账号",
    "deviceMoney.deviceMoney.560758-4": "手机号",
    "deviceMoney.deviceMoney.560758-5": "设备编号",
    "deviceMoney.deviceMoney.560758-6": "设备名称",
    "deviceMoney.deviceMoney.560758-7": "查询",
    "deviceMoney.deviceMoney.560758-8": "导出",
    "deviceMoney.deviceMoney.560758-9": "用户昵称",
    "deviceMoney.deviceMoney.560758-10": "交易金额",
    "deviceMoney.deviceMoney.560758-11": "原来的设备余额",
    "deviceMoney.deviceMoney.560758-12": "现在的设备余额",
    "deviceMoney.deviceMoney.560758-13": "订单编号",
    "deviceMoney.deviceMoney.560758-14": "交易时间",
    "deviceMoney.deviceMoney.560758-15": "暂无数据",
    "deviceMoney.deviceMoney.560758-16": "当前电价",
    "deviceMoney.deviceMoney.560758-17": "当天用电量",
    "deviceMoney.deviceMoney.560758-18": "当天用电费",
    "deviceMoney.deviceMoney.560758-19": "线电损耗",
    "deviceMoney.deviceMoney.560758-20": "公摊电量",
    "deviceMoney.deviceMoney.560758-21": "更新时间",


    //报警表单
    "alert.index.303927-0": "报警状态：",
    "alert.index.303927-1": "请选择报警状态",
    "alert.index.303927-2": "未处理",
    "alert.index.303927-3": "已处理",
    "alert.index.303927-4": "误报",
    "alert.index.303927-5": "起止时间：",
    "alert.index.303927-6": "请选择起止时间",
    "alert.index.303927-7": "搜索",
    "alert.index.303927-8": "全部区域",
    "alert.index.303927-9": "提示",
    "alert.index.303927-10": "是否对设备进行$",
    "alert.index.303927-11": "处理",
    "alert.index.303927-12": "操作"



}


// WEBPACK FOOTER //
// ./src/i18n/lang/Zh/report-zh.js